// Dismissal does not cancel an already accepted server write. It cancels only
// the UI navigation intent. The in-flight lock survives dismissal/reopening.
export function createArtworkCreationGate() {
  let generation=0,pending=null,intentLocation='',mounted=true
  return {
    begin(location=''){if(!mounted||pending!==null)return null;intentLocation=location;pending=++generation;return pending},
    dismiss(){generation++},
    current(ticket,location=''){return mounted&&pending===ticket&&generation===ticket&&intentLocation===location},
    active(){return mounted},
    pending(){return pending!==null},
    mount(){mounted=true},
    unmount(){mounted=false;generation++},
    finish(ticket){if(pending===ticket)pending=null},
  }
}
